import { Box, Center, Image } from '@chakra-ui/react';
import { Photo } from '@prisma/client';
import { useUI } from 'hooks/useUI';
import { cloneElement, ReactChild, ReactElement } from 'react';
import { AiFillEye } from 'react-icons/ai';

interface Props {
	photos: Photo[];
	component?: ReactChild;
}

export default function Gallery({ photos, component }: Props) {
	const { updateSelectedImage } = useUI();

	return (
		<Box
			sx={{
				columnCount: [1, 2, 3],
				columnGap: '8px',
			}}>
			{photos.map((el, idx) =>
				component ? (
					cloneElement(component as ReactElement, { photo: el })
				) : (
					<Box
						key={idx}
						role='group'
						w='100%'
						mb='2'
						borderRadius='8px'
						d='inline-block'
						overflow='hidden'
						rounded='xl'
						pos='relative'
						cursor='pointer'
						onClick={() => updateSelectedImage(el.url)}>
						<Image src={el.url} objectFit='cover' alt='trip photo' />
						<Center
							pos='absolute'
							inset='0'
							bg='transparent'
							transition='all .2s'
							_groupHover={{
								bg: 'charcoal.800',
							}}>
							<Box
								opacity={0}
								scale='75%'
								transition='all .2s'
								_groupHover={{
									scale: '125%',
									opacity: '100%',
								}}>
								<AiFillEye color='white' size={24} />
							</Box>
						</Center>
					</Box>
				)
			)}
		</Box>
	);
}
